import { HighlightStyle, defaultHighlightStyle } from '@codemirror/language';
import { tags } from '@lezer/highlight';

export const classHighlightStyles = HighlightStyle.define([
    { tag: tags.keyword, class: 'h-keyword' },
    { tag: tags.macroName, class: 'h-function' },
    { tag: tags.number, class: 'h-number' },
    { tag: tags.string, class: 'h-string' },
    { tag: tags.name, class: 'h-identifier' },
    { tag: tags.comment, class: 'h-comment' }
]);
// Workaround until I know what is wrong
// https://discuss.codemirror.net/t/highlighting-that-seems-ignored-in-cm6/4320/17
const fn0 = classHighlightStyles.style;
classHighlightStyles.style = (tags) => fn0(tags || []);

const jsonClassHighlightStyles = HighlightStyle.define([
    { tag: tags.string, class: 'h-string' },
    { tag: tags.propertyName, class: 'h-propertyName' },
    { tag: tags.number, class: 'h-number' },
    { tag: tags.bracket, class: 'h-bracket' }
]);
// Workaround until I know what is wrong
// https://discuss.codemirror.net/t/highlighting-that-seems-ignored-in-cm6/4320/17
const fn1 = jsonClassHighlightStyles.style;
jsonClassHighlightStyles.style = (tags) => fn1(tags || []);

export const defaultClassHighlightStyles = defaultHighlightStyle;
const fn2 = defaultHighlightStyle.style;
defaultHighlightStyle.style = (tags) => fn2(tags || []);
